import { gql } from '@apollo/client';

export interface ActivityMessagesData {
  mailMessages: {
    __typename: 'MailMessageNode';
    authorName: null | string;
    body: null | string;
    changeSummary: null | string;
    createDate: null | string;
    id: string;
    messageType: null | string;
    trackingValues:
      | {
          __typename: 'MailTrackingValueNode';
          changeSummary: null | string;
          createDate: null | string;
          createUserName: null | string;
          fieldDescription: null | string;
          fieldId: {
            __typename: 'IrModelFieldsNode';
            id: string;
          } | null;
          fieldName: null | string;
          fieldType: null | string;
          newValue: null | string;
          oldValue: null | string;
        }[]
      | null;
  }[];
}

export interface ActivityMessagesVars {
  recordId: string;
}

export const ACTIVITY_MESSAGES_QUERY = gql`
  query ActivityMessages($recordId: ID) {
    mailMessages(recordId: $recordId) {
      id
      body
      messageType
      createDate
      authorName
      changeSummary
      trackingValues {
        fieldName
        fieldType
        fieldDescription
        changeSummary
        oldValue
        fieldId {
          id
        }
        newValue
        createDate
        createUserName
      }
    }
  }
`;
